export const attachmentConceptionFields = {
    photos: [],
    schemas: [],
    technicalFiles: [],
    reports: [],
    conventions: [],
    others: [],
};
